import React, { useState } from "react";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { bulkgeneratepayslip } from "../../../services/admin";

export default function BulkGenerate() {
    const navigate = useNavigate();
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [paydate, setPayDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [errMsg, setErrMsg] = useState("");

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ];

    function handleGenerate(e) {
        e.preventDefault();
        setSubmit(true);
        setResult(null);
        setErrMsg("");
        if (month === "" || year === "") {
            return;
        }
        setLoading(true);
        const temp = new FormData();
        temp.append("month", month);
        temp.append("year", year);
        temp.append("pay_date", paydate);
        bulkgeneratepayslip(temp).then((res) => {
            setLoading(false);
            if (res && res.status === true) {
                setResult(res.data);
            } else {
                setErrMsg((res && res.message) || "Unable to generate payslips");
            }
        });
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Bulk Generate Payslips</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a>Payslip</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Bulk Generate</li>
                </ol>
            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Generating...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h2 className="main-content-title tx-24 mg-b-5">Generate for a Month</h2>
                                </div>
                                <div className="card-body">
                                    <p className="text-muted">
                                        Generates a payslip for every active staff who has a salary structure, using their
                                        structure and attendance-based LOP. Staff who already have a payslip for the selected
                                        month are skipped.
                                    </p>
                                    <div className="row">
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Month<span className="text-danger"> *</span></label>
                                                <select className="default-select form-control wide" value={month} onChange={(e) => setMonth(e.target.value)}>
                                                    <option value="" disabled>Select Month</option>
                                                    {months.map((item) => (
                                                        <option key={item} value={item}>{item}</option>
                                                    ))}
                                                </select>
                                                {submit && month === "" && (
                                                    <span className="text-danger">Please Select Month</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Year<span className="text-danger"> *</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Year"
                                                    maxLength={4}
                                                    value={year}
                                                    onChange={(e) => {
                                                        const regex = /^[0-9\b]+$/;
                                                        if (e.target.value === "" || regex.test(e.target.value)) {
                                                            setYear(e.target.value);
                                                        }
                                                    }}
                                                />
                                                {submit && year === "" && (
                                                    <span className="text-danger">Please Enter Year</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">Pay Date</label>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={paydate}
                                                        onChange={(e) => setPayDate(e.target.value)}
                                                        onKeyPress={(event) => event.preventDefault()}
                                                        onKeyDown={(event) => event.preventDefault()}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {result !== null && (
                                        <div className="text-success" style={{ fontWeight: 600 }}>
                                            Done. Created {result.created} payslip(s), skipped {result.skipped}
                                            {result.skipped > 0 ? " (already generated or no structure)." : "."}
                                        </div>
                                    )}
                                    {errMsg !== "" && <div className="text-danger" style={{ fontWeight: 600 }}>{errMsg}</div>}

                                    <div className="card-footer">
                                        <div className="text-right">
                                            <a className="btn btn-success me-2" onClick={handleGenerate}>Generate</a>
                                            <a className="btn btn-info me-2" onClick={() => navigate("/payslip/allpayslip")}>View Payslips</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
